<ion-content zooming="true" direction="xy" style="width: 100%; ">
    <iframe #iframe 
    [ngStyle]="{ 'padding':'0px','border':'0px','margin':'0px', 'width': '100%','height':'100%'}" 
    
    allow="accelerometer; autoplay; encrypted-media;gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
</ion-content>
